import { render, staticRenderFns } from "./ValidateAccount.vue?vue&type=template&id=5dee56f4&scoped=true&"
import script from "./ValidateAccount.vue?vue&type=script&lang=ts&"
export * from "./ValidateAccount.vue?vue&type=script&lang=ts&"
import style0 from "./ValidateAccount.vue?vue&type=style&index=0&id=5dee56f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee56f4",
  null
  
)

export default component.exports